import * as React from "react";
import styled from "styled-components";

export const HelperText = styled.div`
    margin-top: 5px;
    color: ${(props) => props.theme.gray};
    font-size: 12px;
`;

interface Props {
    label: string;
    description?: string | React.ReactNode;
    size?: "medium" | "small";
}

const Wrapper = styled.div.attrs((props: { size?: "small" | "medium" }) => ({
    size: props.size ?? "medium",
}))`
    display: flex;
    flex-direction: column;
    margin-bottom: ${(props) => (props.size === "medium" ? "8px" : "2px")};
`;

export const Label = styled.div.attrs((props: { size?: "small" | "medium" }) => ({
    size: props.size ?? "medium",
}))`
    font-weight: 600;
    font-size: ${(props) => (props.size === "small" ? "13px" : "14px")};
    color: black;
`;

function HESPFormLabel({ label, description, size }: Props) {
    return (
        <Wrapper size={size}>
            <Label size={size}>{label}</Label>
            {description && <HelperText style={{ marginTop: "2px" }}>{description}</HelperText>}
        </Wrapper>
    );
}

export default HESPFormLabel;
